function impressionsView(location, products, sku){
  var impressions = [];
  var index = 1;
  if(location == "related"){
    $.each(products,function(i,o){
      if(i != 0 && o.sku){
      	var impression = {};
      	impression["id"] = o.sku;
      	impression["name"] = o.name;
      	impression["list"] = "Related Products - " + sku;
      	impression["position"] = index;
        impression["price"] = o.price;
      	index = index + 1;
      
      	impressions.push(impression);
      }
    });
  } 
  else if(location == "collection"){
  	$.each(products,function(i,o){  
        var impression = {};
    	impression["id"] = o.sku;
      	impression["name"] = o.title;
      	impression["category"] = o.category;
      	impression["list"] = o.category;
      	impression["position"] = index;
        impression["price"] = o.price;
      	index = index + 1;
      
      	impressions.push(impression);
    });
  }
  else if(location == "homepage"){
  	$.each(products,function(i,o){  
        var impression = {};
    	impression["id"] = o.sku;
      	impression["name"] = o.title;
      	impression["list"] = "Homepage";
      	impression["position"] = index;
      	impression["price"] = o.price;
      	index = index + 1;
      
      	impressions.push(impression);
    });
  }
  else if(location == "search"){
  	$.each(products,function(i,o){  
        var impression = {};
    	impression["id"] = o.sku;
      	impression["name"] = o.title;
      	impression["list"] = "Search";
      	impression["position"] = index;
      	index = index + 1;
      
      	impressions.push(impression);
    });
  }else if(location == "automotive"){
    $.each(products,function(i,o){
      if(i != 0 && o.sku){
      	var impression = {};
      	impression["id"] = o.sku;
      	impression["name"] = o.name;
      	impression["list"] = "Automotive";
      	impression["position"] = index;
        impression["price"] = o.price;
      	index = index + 1;
      
      	impressions.push(impression);
      }
    });
  } 
  
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
  'event': 'eec.impressionView',
  'ecommerce': { impressions
  }
  });
}

function productClick(title, sku, category, brand, price, location){
  window.dataLayer = window.dataLayer || [];
  if(category == "Related Products"){
  	window.dataLayer.push({
  		'event': 'eec.impressionClick',
  		'ecommerce': {
	   		'click': {
    			'actionField': {
        			'list': location
      			},
      			'products': [{
        			'id': sku,
        			'name': title,
			        'price': price,
      			}]
    		}
  		}
	});
  } else{
  	window.dataLayer.push({
  		'event': 'eec.impressionClick',
  		'ecommerce': {
	   		'click': {
    			'actionField': {
        			'list': location
      			},
      			'products': [{
        			'id': sku,
        			'name': title,
			        'price': price,
                  	'category': category,
                  	'brand' : brand,
      			}]
    		}
  		}
	});
  }
}

function addToCart(sku, name, brand, quantity, price){
	var qty = $("#" + quantity).val();
  	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
  		'event': 'eec.add',
  			'ecommerce': {
    		'add': {
      			'actionField': {
        			//'list': 'Shopping cart'
      			},
      		'products': [{
        		'id': sku,
        		'name': name,
        		'brand': brand,
        		'quantity': qty,
              	'price': price,
      		}]
    		}
  			}
	});
}

function cartUpdate(sku, name, brand, old_quantity, new_quantity_field, price){
  var new_quantity = 0;	
  if(new_quantity_field == 0)
    new_quantity = 0;
  else
	new_quantity = $("#" + new_quantity_field).val();
  
  	var diff = new_quantity - old_quantity;
  
  	if(diff > 0) { // quantity added in cart.
    	window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
  		'event': 'eec.add',
  		'ecommerce': {
    		'add': {
      			'actionField': {
        			//'list': 'Shopping cart'
      			},
      		'products': [{
        		'id': sku,
        		'name': name,
        		'brand': brand,
        		'quantity': diff,
              	'price': price,
      		}]
    		}
  			}
	    });
  	}
  	else if(diff < 0) { // quantity removed from cart.
    	window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
  		'event': 'eec.remove',
  			'ecommerce': {
    		'remove': {
      			'actionField': {
        			//'list': 'Shopping cart'
      			},
      		'products': [{
        		'id': sku,
        		'name': name,
        		'brand': brand,
        		'quantity': -(diff),
              	'price': price,
      		}]
    		}
  			}
	    });
  	}  	
}

function checkoutOption(step, products){
  window.dataLayer = window.dataLayer || [];
  if(step == "contact_information"){
	window.dataLayer.push({
  		'event': 'eec.checkout',
  		'ecommerce': {
    		'checkout': {
      			'actionField': {
        			'step': 1
      			},
                'products': products
            }
         }
    });
  } else if(step == "shipping_method"){
    window.dataLayer.push({
  		'event': 'eec.checkout',
  		'ecommerce': {
    		'checkout': {
      			'actionField': {
        			'step': 2
      			},
            }
         }
    });
  
  } else if(step == "payment_method"){
  	window.dataLayer.push({
  		'event': 'eec.checkout',
  		'ecommerce': {
    		'checkout': {
      			'actionField': {
        			'step': 3
      			},
            }
         }
    });
  }
}